/**
 * Central place for resolving the backend origin.
 *
 * Web builds: VITE_API_BASE is unset, all URLs stay relative (same-origin).
 * Native (Capacitor) builds: built with `--mode mobile`, where .env.mobile
 * sets VITE_API_BASE to the production server, since the WebView origin
 * (https://localhost) has no backend of its own.
 */
export const API_BASE: string = ((import.meta.env.VITE_API_BASE as string | undefined) ?? "").replace(/\/+$/, "");

/** Prefix an absolute-path API route (e.g. "/api/lobby") with the configured base. */
export function apiUrl(path: string): string {
  return API_BASE ? `${API_BASE}${path}` : path;
}

/** Resolve the WebSocket endpoint, honoring the configured base. */
export function wsUrl(path = "/ws"): string {
  if (API_BASE) {
    return `${API_BASE.replace(/^http/, "ws")}${path}`;
  }
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}${path}`;
}
